import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { NotificationService } from '@appStore/account/services/notification.service';
import { ActionTypes } from '@appStore/account/actions';
import * as actions from '@appStore/account/actions';

@Injectable()
export class NotificationsEffects {
  constructor(private router: Router, private notificationService: NotificationService, private actions$: Actions) {}

  loadNotifications$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(ActionTypes.NotificationLoadData),
      exhaustMap(action => {
        return this.notificationService.getMyNotifications().pipe(
          map(notifications => new actions.NotificationLoadSuccess(notifications)),
          catchError(error => of(new actions.NotificationLoadFail(error)))
        );
      })
    );
  });

  removeNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.NotificationRemove),
      map((action: actions.NotificationRemove) => action.payload),
      exhaustMap(item =>
        this.notificationService.removeNotification(item).pipe(
          map(() => new actions.NotificationRemoveSuccess(item)),
          catchError(error => of(new actions.NotificationRemoveFail(error)))
        )
      )
    );
  });

  bulkRemoveNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.NotificationBulkRemove),
      map((action: actions.NotificationBulkRemove) => action.payload),
      exhaustMap(ids =>
        this.notificationService.bulkRemoveNotification(ids).pipe(
          map(() => new actions.NotificationBulkRemoveSuccess(ids)),
          catchError(error => of(new actions.NotificationBulkRemoveFail(error)))
        )
      )
    );
  });

  loadNotificationsInterval$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(ActionTypes.NotificationIntervalLoadData),
      map((action: actions.NotificationLoadInterval) => action.payload),
      exhaustMap(interval => {
        return this.notificationService.getMyNotificationsInterval(interval).pipe(
          map(notifications => new actions.NotificationLoadIntervalSuccess(notifications)),
          catchError(error => of(new actions.NotificationLoadIntervalFail(error)))
        );
      })
    );
  });
  
  loadUnreadNotificationsCount$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(ActionTypes.NotificationLoadUnreadCount),
      exhaustMap(action => {
        return this.notificationService.getMyUnreadNotificationsCount().pipe(
          map(count => {
            return new actions.NotificationLoadUnreadCountSuccess(count);
          }),
          catchError(error => of(new actions.NotificationLoadUnreadCountFail(error)))
        );
      })
    );
  });
  
  loadNotificationsCount$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(ActionTypes.NotificationLoadCount),
      exhaustMap(action => {
        return this.notificationService.getMyNotificationsCount().pipe(
          map(count => {
            return new actions.NotificationLoadCountSuccess(count);
          }),
          catchError(error => of(new actions.NotificationLoadCountFail(error)))
        );
      })
    );
  });
  
  setNotificationAsRead$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(ActionTypes.NotificationSetAsRead),
      map((action: actions.NotificationSetAsRead) => action.payload),
      exhaustMap(notification => {
        return this.notificationService.setNotificationAsRead(notification).pipe(
          map(updatedItem => new actions.NotificationSetAsReadSuccess(updatedItem)),
          catchError(error => of(new actions.NotificationSetAsReadFail(error)))
        );
      })
    );
  });
  
  setNotificationIntervalAsRead$ = createEffect(() => {
    return  this.actions$.pipe(
      ofType(ActionTypes.NotificationIntervalSetAsRead),
      map((action: actions.NotificationIntervalSetAsRead) => action.payload),
      exhaustMap(interval => {
        return this.notificationService.SetMyNotificationIntervalAsRead(interval).pipe(
          map(updatedItems => new actions.NotificationIntervalSetAsReadSuccess(updatedItems)),
          catchError(error => of(new actions.NotificationIntervalSetAsReadFail(error)))
        );
      })
    );
  });
  
 
}
